import React from 'react'
import PropTypes from 'prop-types'
import SuggestionChip from '../common/SuggestionChip'
import FlexRow from '../../../../components/molecules/FlexRow'

const SUGGESTION_PROMPTS = [
  'Show me top clients by AUM',
  'Do I have any client concentration risk?',
  'What are our most significant growth opportunities?',
  'Find clients with risk indicators',
  'What are the most significant risk indicators for my business?',
  'How should I use Denali AI?'
]

function SuggestionList ({ onSuggestionClick, suggestions }) {
  return (
    <FlexRow className='gap-md flex-wrap justify-center'>
      {suggestions.map((prompt, index) => (
        <SuggestionChip
          key={index}
          onClick={() => onSuggestionClick?.(prompt)}
        >
          {prompt}
        </SuggestionChip>
      ))}
    </FlexRow>
  )
}

SuggestionList.propTypes = {
  onSuggestionClick: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.string)
}

SuggestionList.defaultProps = {
  suggestions: SUGGESTION_PROMPTS
}

export default SuggestionList
